import moment from "moment";
import DatePickerComponent from "../../../../components/date-picker/date-picker.component";
import paginationComponent from "../../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../../components/single-select/single-select.component";
import SelectSiteSearchInputComponent from "../../../../components/site/select-site-search-input.component";
import SelectUserComponent from "../../../../components/user/select-user.component";
import { formats as FORMATS, codeMasterType } from "../../../../config/constants";
import loginModel from "../../../../models/login.model";
import SMSLogModel from "../../../../models/sms-log/sms-log.model";
import ViewBase from "../../../view-base.view";

/**
 * SMS Log
 *
 *
 * @author cmc.kmduc1(Henry)
 */

export default function SMSLogSmeView() {
  ViewBase.call(this);

  const DEFAULT_FILTERS = Object.freeze({
    fromDate: moment().format(FORMATS.ISO_DATE_FORMAT),
    toDate: moment().format(FORMATS.ISO_DATE_FORMAT),
    messageType: '',
    senders: [],
    sites: [],
    mobile: '',
    replyMessageContent: '',
    division: '',
    successStatus: '',
  });

  const DEFAULT_PAGINATION = Object.freeze({
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0
  });

  let filters = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);
  let currentFilters = structuredClone(DEFAULT_FILTERS);

  let messageTypes = [];
  let divisions = [];
  let successStatus = [];

  let tableData = [];

  const getMessageTypes = () => {
    const params = {
      countryCode: loginModel.credentials.country
    }
    SMSLogModel.getCodeMasterByCategory(codeMasterType.smsLogMessageType, params)
      .then(result => {
        messageTypes = result
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const getDivisions = () => {
    const params = {
      countryCode: loginModel.credentials.country
    }
    SMSLogModel.getCodeMasterByCategory(codeMasterType.smsLogDivisionType, params)
      .then(result => {
        divisions = result
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const getSMSLogStatus = () => {
    const params = {
      countryCode: loginModel.credentials.country
    }
    SMSLogModel.getCodeMasterByCategory(codeMasterType.smsLogStatus, params)
      .then(result => { successStatus = result })
      .catch(error => {
        this.handleError(error)
      })
  }

  const getSMSLog = () => {
    this.showLoading();

    const body = {
      fromDate: currentFilters.fromDate,
      toDate: currentFilters.toDate,
      messageType: currentFilters.messageType,
      senderNo: currentFilters.senders.length > 0 ? currentFilters.senders[0].userID : '',
      siteIds: currentFilters.sites.map(site => site.siteId),
      recipient: currentFilters.mobile,
      searchText: currentFilters.replyMessageContent,
      division: currentFilters.division,
      status: currentFilters.successStatus,
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize
    }

    SMSLogModel.getSMSLog(body)
      .then(result => {
        tableData = result.data
        pagination.pageIndex = result.pageIndex
        pagination.pageSize = result.pageSize
        pagination.totalItems = result.total
      })
      .catch(error => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading()
      });
  }

  const handleSearchClick = () => {
    currentFilters = structuredClone(filters)
    pagination.pageIndex = 1

    getSMSLog()
  }

  const handleClear = () => {
    filters = structuredClone(DEFAULT_FILTERS);
  }

  const handlePageIndexChange = (pageIndex) => {
    pagination.pageIndex = pageIndex
    getSMSLog()
  }

  const handlePageSizeChange = (pageIndex, pageSize) => {
    pagination.pageSize = pageSize
    pagination.pageIndex = pageIndex
    getSMSLog()
  }

  const handlePeriodChange = (e) => {
    filters.fromDate = moment(e.detail.start).format(FORMATS.ISO_DATE_FORMAT);
    filters.toDate = moment(e.detail.end).format(FORMATS.ISO_DATE_FORMAT);
  }

  const handleMessageTypeChange = (messageType) => {
    filters.messageType = messageType;
  }

  const handleSenderChange = (senders) => {
    filters.senders = senders;
  }

  const handleSiteChange = (sites) => {
    filters.sites = sites;
  }

  const handleMobileChange = (e) => {
    filters.mobile = e.target.value;
  }

  const handleReplyMessageContentChange = (e) => {
    filters.replyMessageContent = e.target.value;
  }

  const handleDivisionChange = (division) => {
    filters.division = division;
  }

  const handleSuccessStatusChange = (successStatus) => {
    filters.successStatus = successStatus;
  }

  const handleExcelDownloadClick = () => {
    this.showLoading();

    const body = {
      fromDate: currentFilters.fromDate,
      toDate: currentFilters.toDate,
      countryCode: loginModel.credentials.country,
      status: currentFilters.successStatus,
      recipient: currentFilters.mobile,
      messageType: currentFilters.messageType,
      searchText: currentFilters.replyMessageContent,
      channel: currentFilters.sites.map(site => site.siteId).join('^'),
      condition: '',
      senderNo: currentFilters.senders.length > 0 ? currentFilters.senders[0].userID : '',
      division: currentFilters.division,
    }

    SMSLogModel.commonExcelExport(body, `smsLog_${moment().format('YYYYMMDDHHmm')}`)
      .catch(error => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading()
      });
  }

  return {
    oninit: () => {
      getMessageTypes()
      getDivisions()
      getSMSLogStatus()
      getSMSLog()
    },

    view: () => {
      return [
        /* FILTER TOGGLE */
        m('.d-flex.justify-content-end.mb-2',
          m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="true"]',
            m('i.bi.bi-filter'),
            this.getText("LT00000232", "Filter"),
          ),
        ),

        /* SEARCH */
        m("#search-section.collapse.show",
          m('.card.mb-3',
            m(".card-body",
              m(".row.g-2",
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m("label.form-label[for=period]",
                    this.getText("LT00000150", "Period")
                  ),
                  m(DatePickerComponent, {
                    id: 'period',
                    class: 'form-control',
                    isRange: true,
                    minDays: 1,
                    dateStart: filters?.fromDate,
                    dateEnd: filters?.toDate,
                    onselect: handlePeriodChange
                  })
                ),
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m('label.form-label[for="messageType"]',
                    this.getText("LT00001048", "Message Type")
                  ),
                  m(SingleSelectComponent, {
                    id: "messageType",
                    items: messageTypes,
                    keyOnly: true,
                    allowEmpty: true,
                    filterable: false,
                    selectedItem: filters.messageType,
                    onSelect: handleMessageTypeChange
                  })
                ),
                m('.col-xl-3.col-lg-4.col-sm-6',
                  m('label.form-label[for=sender]', this.getText('LT00000038', 'Sender')),
                  m('div',
                    m(SelectUserComponent, {
                      id: 'sender',
                      required: true,
                      multiple: false,
                      selectedUserList: filters.senders,
                      onSelect: handleSenderChange
                    })
                  )
                ),
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m('label.form-label[for="sites"]', this.getText("LT00000071", "Site")),
                  m(SelectSiteSearchInputComponent, {
                    id: 'sites',
                    multiple: true,
                    selectedItems: filters.sites,
                    onSelect: handleSiteChange,
                  })
                ),
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m('label.form-label[for="mobile"]', this.getText("LT00000784", "Mobile")),
                  m('input.form-control.form-control-bg',
                    {
                      id: 'mobile',
                      onchange: handleMobileChange,
                      placeholder: this.getText("LT00000784", "Mobile"),
                      value: filters.mobile
                    })
                ),
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m('label.form-label[for="replyMessageContent"]', this.getText("LT00001049", "Received Message Content")),
                  m('input.form-control.form-control-bg',
                    {
                      id: 'replyMessageContent',
                      onchange: handleReplyMessageContentChange,
                      placeholder: this.getText("LT00001049", "Received Message Content"),
                      value: filters.replyMessageContent
                    })
                ),
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m('label.form-label[for="division"]',
                    this.getText("LT00000233", "Division")
                  ),
                  m(SingleSelectComponent, {
                    id: "division",
                    items: divisions,
                    keyOnly: true,
                    allowEmpty: true,
                    filterable: false,
                    selectedItem: filters.division,
                    onSelect: handleDivisionChange
                  })
                ),
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m('label.form-label[for="successStatus"]',
                    this.getText("LT00001058", "Success Status")
                  ),
                  m(SingleSelectComponent, {
                    id: "successStatus",
                    items: successStatus,
                    keyOnly: true,
                    allowEmpty: true,
                    filterable: false,
                    selectedItem: filters.successStatus,
                    onSelect: handleSuccessStatusChange
                  })
                ),
                m(".col-12.d-flex.justify-content-end.gap-2",
                  m("button.btn.btn-primary",
                    {
                      type: "submit",
                      onclick: handleSearchClick
                    },
                    this.getText("LT00000001", "Search")
                  ),
                  m("button.btn.btn-white",
                    {
                      type: "button",
                      onclick: handleClear
                    },
                    this.getText("LT00000031", "Clear")
                  )
                )
              )
            )
          )
        ),

        /* TABLE */
        m(".card",
          m(".card-body",
            m(".row.g-2",
              m(".col-12.d-flex.justify-content-end",
                m('a.btn.btn-primary', { onclick: handleExcelDownloadClick },
                  m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                )
              ),
              m(".col-12",
                m(".table-responsive",
                  m("table.table.table-hover",
                    m("thead",
                      m("tr.align-middle.text-center",
                        m('th[scope="col"]',
                          this.getText("LT00001048", "Message Type")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001051", "Sender ID")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001052", "Sender Name")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001053", "Received Message")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00000800", "Channel Name")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001054", "Recipient")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001055", "Reply Message")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001056", "Sender Port")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001057", "Send Date")
                        )
                      )
                    ),
                    m("tbody",
                      tableData.length == 0 &&
                      m("tr.align-middle",
                        m("td[colSpan=13]",
                          this.getText("EM00000141", "No records found.")
                        )
                      ),
                      tableData.length > 0 &&
                      tableData.map((data, index) =>
                        m("tr.align-middle",
                          m("td", m("span.cursor-text", data.messageType)),
                          m("td", m("span.cursor-text", data.senderID)),
                          m("td", m("span.cursor-text", data.senderName)),
                          m("td", m("span.cursor-text", data.receivedMessage)),
                          m("td", m("span.cursor-text", data.siteName)),
                          m("td", m("span.cursor-text", data.recipient)),
                          m("td", { style: "white-space: initial" }, m("span.cursor-text", data.replyMessage)),
                          m("td", m("span.cursor-text", data.senderPort)),
                          m("td", m("span.cursor-text", data.sendDate))
                        )
                      )
                    )
                  )
                ),
              ),
              m(".col-12",
                m(paginationComponent, {
                  currentPage: pagination.pageIndex,
                  pageSize: pagination.pageSize,
                  totalItems: pagination.totalItems,
                  onPageChanged: handlePageIndexChange,
                  onPageSizeChanged: handlePageSizeChange
                })
              )
            )
          )
        ),
        this.getBaseViews(),
      ];
    },
  };
}
